import Litepicker from 'litepicker'
import format from 'date-format'

class DatePicker {
  picker = null
  startDateInput = null
  endDateInput = null

  constructor(element) {
    this.startDateInput = document.querySelector(
      element.getAttribute('data-start-date-input')
    )
    this.endDateInput = document.querySelector(
      element.getAttribute('data-end-date-input')
    )

    this.picker = new Litepicker({
      element: element,
      singleMode: false,
      startDate: this.startDateInput.value,
      endDate: this.endDateInput.value,
      minDate: element.getAttribute('data-min-date'),
      maxDate: element.getAttribute('data-max-date'),
      autoApply: true,
      mobileFriendly: true,
      format: 'MMM D, YYYY',
      onSelect: (startDate, endDate) => {
        this.updateDateInputs(startDate, endDate)
      },
    })
  }

  updateDateInputs(startDate, endDate) {
    this.startDateInput.value = format.asString('yyyy-MM-dd', startDate)
    this.endDateInput.value = format.asString('yyyy-MM-dd', endDate)
  }
}

document.addEventListener('turbolinks:load', () => {
  const datepickers = document.querySelectorAll('.js-date-picker')

  datepickers.forEach(element => {
    new DatePicker(element)
  })
})
